import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface timeState {
  timeRemain: number;
  endTime: number;
  pauseSubmit: boolean;
  codeRunning: boolean;
  accessKey: string;
  videoRecording: boolean;
  shouldMarkUnattempted: boolean;
  waitingForUnAttemptedMark: boolean;
  restrictTextualNavigation: boolean;
  textualQuestionSkip: number;
  textualQuestionSave: number;
  goToNextQuestion: number;
}

const initialState: timeState = {
  timeRemain: Infinity,
  endTime: Infinity,
  pauseSubmit: false,
  codeRunning: false,
  accessKey: '',
  videoRecording: false,
  shouldMarkUnattempted: false,
  waitingForUnAttemptedMark: false,
  restrictTextualNavigation: false,
  textualQuestionSave: 0,
  textualQuestionSkip: 0,
  goToNextQuestion: 0,
};

export const timeSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setTimeRemain: (state, action: PayloadAction<number>) => {
      state.timeRemain = action.payload;
    },
    setEndTime: (state, action: PayloadAction<number>) => {
      state.endTime = action.payload;
    },
    setPauseSubmit: (state, action: PayloadAction<boolean>) => {
      state.pauseSubmit = action.payload;
    },
    setCodeRunning: (state, action: PayloadAction<boolean>) => {
      state.codeRunning = action.payload;
    },
    setAccessKey: (state, action: PayloadAction<string>) => {
      state.accessKey = action.payload;
    },
    setVideoRecording: (state, action: PayloadAction<boolean>) => {
      state.videoRecording = action.payload;
    },
    setMarkAsUnattempted: (state, action: PayloadAction<boolean>) => {
      state.shouldMarkUnattempted = action.payload;
    },
    setWaitingForUnAttemptedMark: (state, action: PayloadAction<boolean>) => {
      state.waitingForUnAttemptedMark = action.payload;
    },
    setTextualQuestionSkip: (state, action: PayloadAction<number>) => {
      state.textualQuestionSkip = action.payload;
    },
    setTextualQuestionSave: (state, action: PayloadAction<number>) => {
      state.textualQuestionSave = action.payload;
    },
    setRestrictTextualNavigation: (state, action: PayloadAction<boolean>) => {
      state.restrictTextualNavigation = action.payload;
    },
    setGoToNextQuestion: (state, action: PayloadAction<number>) => {
      state.goToNextQuestion = action.payload;
    },
  },
});

export const {
  setTimeRemain,
  setEndTime,
  setPauseSubmit,
  setCodeRunning,
  setAccessKey,
  setVideoRecording,
  setMarkAsUnattempted,
  setWaitingForUnAttemptedMark,
  setTextualQuestionSkip,
  setTextualQuestionSave,
  setRestrictTextualNavigation,
  setGoToNextQuestion,
} = timeSlice.actions;

export default timeSlice.reducer;
